module.exports = "/_next/static/images/img__calendar-439c3ce680b6def6be206f7cb776a1ff.png";